import React from 'react';
import {Box, Dialog, Paper, Typography} from '@mui/material';
import {getSettingsColors, settingsInputStyles} from '../SettingsDesign';

export const subscriptionInset = {bgcolor: theme => getSettingsColors(theme).inset, borderRadius: '10px', p: 2};

export function SubscriptionCard({children, sx = [], ...props}) {
    return <Paper {...props} elevation={0} sx={[
        {
            position: 'relative', minWidth: 0, border: '1px solid', borderColor: 'divider', borderRadius: '12px',
            bgcolor: theme => getSettingsColors(theme).card, p: {xs: 2, md: 3},
            '& .MuiTypography-root': {whiteSpace: 'normal'}, '& .MuiButton-root': {borderRadius: '8px'}
        }, ...(Array.isArray(sx) ? sx : [sx])
    ]}>{children}</Paper>;
}

export function SubscriptionSectionTitle({icon: Icon, title, description}) {
    return <Box sx={{mb: 2.5}}>
        <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
            <Icon sx={{fontSize: 21, color: 'text.secondary'}}/>
            <Typography component="h2" sx={{fontSize: 16, fontWeight: 600}}>{title}</Typography>
        </Box>
        {description && <Typography sx={{fontSize: 13, color: 'text.secondary', mt: 0.75}}>{description}</Typography>}
    </Box>;
}

export function SubscriptionDialog({sx = [], ...props}) {
    return <Dialog {...props} sx={[
        {
            '& .MuiDialog-paper': {
                ...settingsInputStyles, bgcolor: theme => getSettingsColors(theme).card, color: 'text.primary',
                border: theme => theme.palette.mode === 'dark' ? '1px solid' : 0, borderColor: 'divider',
                borderRadius: {xs: 0, sm: '16px'}, backgroundImage: 'none',
                '& .MuiOutlinedInput-notchedOutline': {border: 0}, '& .MuiButton-root': {borderRadius: '8px'},
                '& .MuiTypography-root': {whiteSpace: 'normal'}, '& .MuiDivider-root': {borderColor: 'divider'}
            },
            '& .MuiDialogTitle-root': {textAlign: 'left', fontSize: 22, fontWeight: 700, m: 0, px: {xs: 2, sm: 3}, pt: 3, pb: 2, border: 0},
            '& .MuiDialogContent-root': {px: {xs: 2, sm: 3}, pt: 1, pb: 2, scrollbarGutter: 'stable'},
            '& .MuiDialogActions-root': {px: {xs: 2, sm: 3}, py: 2, border: 0, gap: 1}
        }, ...(Array.isArray(sx) ? sx : [sx])
    ]}/>;
}
